var _rect, _path, _path2, _rect2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNiceHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nice Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#004A93",
    y: 0,
    width: 80,
    height: 80
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.91,49.83h3.78L39,61.42l0-11.59h3.53V67.07H38.71L31.53,55.46V67.07H27.91Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.66,49.84h3.45v2.8H44.66V49.92",
    transform: "translate(0 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: 44.66,
    y: 54.53,
    width: 3.44,
    height: 12.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.29,59h3.37a5.72,5.72,0,0,0-.33-1.54,4.84,4.84,0,0,0-2.55-2.6,7.12,7.12,0,0,0-6.94.61C49,57.5,48.36,63,51.44,65.92c2,1.82,6.06,2,8.07.36a5.05,5.05,0,0,0,2.23-4H58.41a4.18,4.18,0,0,1-.45,1.3,2.63,2.63,0,0,1-4.49-.08,6.08,6.08,0,0,1,.28-5.75,2.72,2.72,0,0,1,3.84-.28l.09.08A2.34,2.34,0,0,1,58.29,59",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.83,59.48H66.24s.05-.36.08-.49a2.78,2.78,0,0,1,5.43,0c0,.21.08.49.08.49m3.45,1.46a6.86,6.86,0,0,0-2.68-5.71,6.59,6.59,0,0,0-7,0c-3.33,2.07-4.06,8.22-.32,11a7.17,7.17,0,0,0,7.58.08A6.11,6.11,0,0,0,75,63.17H72a1.25,1.25,0,0,1-.2.4c-1.1,1.58-4.25,1.74-5.19-.2a4,4,0,0,1-.4-1.74h9v-.69",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNiceHeader);
export default __webpack_public_path__ + "static/media/logo-nice-header.6d80bfeca48418be360a1971da3a99ae.svg";
export { ForwardRef as ReactComponent };